export default "__VITE_ASSET__bf667851__"